import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import AdminFilterBar from './components/AdminFilterBar';
import AdminDataTable from './components/AdminDataTable';
import MainButton from '../../../shared/layout/buttons/MainButton';
import { fetchAdminBillingProfiles } from '../../../services/Http/AdminApi';

const AdminBillingProfiles = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const resp = await fetchAdminBillingProfiles({ per_page: 25 });
            setRows(resp?.data || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to load billing profiles');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const columns = useMemo(() => ([
        { key: 'organization_name', label: 'Organization' },
        { key: 'stripe_customer_id', label: 'Stripe Customer' },
        { key: 'payment_method_id', label: 'Payment Method' },
        { key: 'card_brand', label: 'Card Brand' },
        { key: 'card_last_four', label: 'Last 4' },
        { key: 'is_subscribed', label: 'Subscribed', render: (r) => r.is_subscribed ? 'Yes' : 'No' },
        { key: 'updated_at', label: 'Updated', render: (r) => r.updated_at ? new Date(r.updated_at).toLocaleString() : '—' },
    ]), []);

    return (
        <PageContainer>
            <PageHeader><PageTitle>Billing Profiles</PageTitle></PageHeader>
            <PageContent>
                <AdminFilterBar><div>Organization billing and payment method state</div><MainButton size="small" onClick={load}>Refresh</MainButton></AdminFilterBar>
                <AdminDataTable columns={columns} rows={rows} loading={loading} emptyText="No billing profiles" />
            </PageContent>
        </PageContainer>
    );
};

export default AdminBillingProfiles;

